import React from 'react';
import { Router, Route, hashHistory } 	from 'react-router';
import Intro from './Intro';
import Home  from './Home';
import Sizes  from './Sizes';
import Tutorial  from './Tutorial';
import TabFb  from './TabFb';

class App extends React.Component {

	requireAuth(nextState, replace) {
		if (!localStorage.loggedUser) {
			replace({pathname: '/'});
		}
	}

	disable(nextState, replace) {
		replace({pathname: '/'});
	}

	render() {
		return (
			<Router history={hashHistory}>
				<Route path="/" 	   component={Intro} />
				<Route path="/home"    component={Home} onEnter={this.disable} />
				<Route path="/tutorial"    component={Tutorial} onEnter={this.disable} />
				<Route path="/tab" 	   component={TabFb} />
				<Route path="/sizes" 	   component={Sizes} />
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js